import { IAccountDetailsDTO } from '../api/accounts.dao';
import { IEventDetailsDTO } from '../api/events.dao';

abstract class IGlobalStorage {
    public abstract setEvent(event: IEventDetailsDTO);

    public abstract getEvent(): IEventDetailsDTO | undefined;

    public abstract setAccount(account: IAccountDetailsDTO): void;

    public abstract getAccount(): IAccountDetailsDTO | undefined;
}

export { IGlobalStorage };
